import { createContext, useContext } from 'react'

export const SearchContext = createContext<() => void>(() => {})
export const useSiteSearch = () => useContext(SearchContext)

export type SearchAnalyticsEvent =
  | { type: 'search'; term: string; resultCount: number }
  | { type: 'zero_results'; term: string }
  | { type: 'result_clicked'; term: string; resultId: string; url: string }

let analyticsHandler: ((event: SearchAnalyticsEvent) => void) | undefined
/** Optional integration with an approved analytics provider. No default logging or network calls. */
export function setSearchAnalyticsHandler(handler?: (event: SearchAnalyticsEvent) => void) {
  analyticsHandler = handler
}
export function reportSearchEvent(event: SearchAnalyticsEvent) {
  try { analyticsHandler?.(event) } catch { /* Analytics must never interrupt search. */ }
}
